import common from '../common'

export default {
    list(params) {
      return common.get('/rocheManage/meeting/pubMeeting/myMeetingList',params);
    },
  
    add(params) {
      return common.post('/rocheManage/meeting/pubMeeting/add',params);
    },
  
    edit(params) {
      return common.put('/rocheManage/meeting/pubMeeting/edit',params);
    },
  
    delete(params) {
      return common.delete('/rocheManage/meeting/pubMeeting/delete',params);
    },

    exportXls(params) {
      return common.get('/rocheManage/meeting/pubMeeting/myMeetingExportXls', params, {responseType: 'blob'});
    },
  
    batchSubmit(params) {
      return common.put('/rocheManage/meeting/pubMeeting/myMeetingSubmit',params);
    },
  
    cancle(params) {
      return common.delete('/rocheManage/meeting/pubMeeting/cancelBatch',params);
    },
  
    queryById(params) {
      return common.get('/rocheManage/meeting/pubMeeting/queryById',params);
    },

    queryMainApplication(params) {
      return common.get('/rocheManage/meeting/pubMeeting/myMeetingSummary',params);
    },

    getCanCreateMeeting(params) {
      return common.get('/rocheManage/meeting/pubMeeting/getCanCreateMeeting',params);
    },

    filterMeetingCode(params) {
      return common.get('/rocheManage/meeting/pubMeeting/getMeetingCode',params);
    },

    filterMeetingCreator(params) {
      return common.get('/rocheManage/meeting/pubMeeting/getMeetingCreator',params);
    },

    filterMeetingOrganizer(params) {
      params.name = params.name.toUpperCase();
      return common.get('/rocheManage/meeting/pubMeeting/getMeetingOrganizer',params);
    },

    filterHospital(params) {
      return common.get('/rocheManage/external/externalHospital/list',params);
    },

    saveMeetingApprove(params) {
      return common.post('/rocheManage/meeting/pubMeeting/saveMeetingApprove',params);
    },

    submitMeetingApprove(params) {
      return common.post('/rocheManage/meeting/pubMeeting/submitMeetingApprove',params);
    },

    queryMeetingPropAndTypeSelect(params) {
      return common.get('/rocheManage/meeting/pubMeeting/meetingPropAndTypeSelect',params);
    },

    queryAreaRelationList(params) {
      return common.get('/rocheManage/external/externalAreaRelation/list',params);
    },
}


// WEBPACK FOOTER //
// ./src/api/meetingplan/application.js